<template>
  <div>
    <BaseButton buttonClass="-fill-gradient-cta" @click="toggleModal"
      >GO TO CHECKOUT</BaseButton
    >
    <transition name="fade">
      <div v-if="isOpen" class="modal">
        <h2>My Bag</h2>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <span>
          <BaseButton buttonClass="-fill-gradient-cta" @click="toggleModal"
            >PURCHASE</BaseButton
          >
        </span>
        <span>
          <BaseButton buttonClass="-fill-gradient-cta" @click="toggleModal"
            >Continue shopping</BaseButton
          >
        </span>
        <br />
        <br />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleModal() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped>
.modal {
  background: rgba(128, 128, 128, 0.301);
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-out;
}
.fade-leave-to {
  opacity: 0;
}
</style>
